import { useTimeSyncStatus } from "#/services/time/hooks/useTimeSyncStatus";
import { useIsTimeSyncWarningDismissed } from "#/store/app/alerts/isTimeSyncWarningDismissed";

export const useTimeSyncWarningController = () => {
  const { isTimeSyncWarningDismissed, setIsTimeSyncWarningDismissed } =
    useIsTimeSyncWarningDismissed();
  const { data } = useTimeSyncStatus();
  const description = `Your device's time differs from the server by ~${data?.seconds} seconds. Please sync your device time and date so time sensitive signatures can work as expected.`;

  const isInvisible = !data?.shouldShowWarning || isTimeSyncWarningDismissed;

  const dismiss = () => {
    setIsTimeSyncWarningDismissed(true);
  };

  return { isInvisible, description, dismiss };
};
